import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as XTwitterIcon } from '../../assets/icons/square-x-twitter-brands-solid.svg';
import { BUSINESS } from "../../seo/seoConfig";

function Footer(props) {
  const [showModal, setShowModal] = useState(false);
  const [emails, setEmails] = useState({ info: '', support: '' });
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  useEffect(() => {
    // Construye emails sin que los bots los detecten
    const infoEmail = 'inf' + 'o' + '@' + 'gekk' + 'onect' + '.' + 'com';
    const supportEmail = 'supp' + 'ort' + '@' + 'gekk' + 'onect' + '.' + 'com';
    
    setEmails({
      info: infoEmail,
      support: supportEmail
    });
  }, []);
  
  return (
    <>
      <footer className={props.footerAddclass} >
        <div className="container">
          <div className="footer-top">
            <div className="row">
              <div className="col-md-3 col-lg-3 col-xl-3">
                <div className="footer-widget">
                  <div className="footer-logo">
                    <Link scrollTo={scrollTop} to={"/"}>
                      <img 
                        src={process.env.PUBLIC_URL + "/img/webp/logo-gekkonect-last-round.webp"} 
                        alt="Gekkonect — desarrollo de software y cloud en México" 
                        loading="lazy"
                        width="300"
                        height="70"
                      />
                    </Link>
                  </div>
                  <p>
                    <strong>Software empresarial, cloud AWS y agentes IA</strong> (Gekko-AI) para equipos en México que necesitan integración real, no solo entregables aislados.
                  </p>
                  <ul className="social-media-icons">
                    <li>
                      <a href="https://www.linkedin.com/company/gekkonect" aria-label="Linkedin">
                        <i className="fab fa-linkedin" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/" aria-label="Facebook">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/gekkonectAI" target="_blank" rel="noopener noreferrer" aria-label="X">
                        <XTwitterIcon style={{ fill: 'white', width: 23, height: 23 }} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-3">
                <div className="footer-widget">
                </div>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-3">
                <div className="footer-widget">
                  <h4>Accesos Rápidos</h4>
                  <ul className="footer-menu">
                    <li>
                      <Link to={`${process.env.PUBLIC_URL}/about`} onClick={scrollTop}>Nosotros</Link>
                    </li>
                    <li>
                      <Link to={`${process.env.PUBLIC_URL}/service`} onClick={scrollTop}>Servicios</Link>
                    </li>
                    <li>
                      <Link to={`${process.env.PUBLIC_URL}/gekko-ai`} onClick={scrollTop}>Gekko-AI</Link>
                    </li>
                    <li>
                      <Link to={`${process.env.PUBLIC_URL}/contact`} onClick={scrollTop}>Contacto</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-3">
                <div className="footer-widget">
                  <h4>Contacto Gekkonect</h4>
                  <div className="number">
                    <div className="num-icon">
                      <i className="fas fa-phone-alt" />
                    </div>
                    <div className="phone">
                      <a href={BUSINESS.telHref[0]} aria-label="Teléfono Gekkonect">{BUSINESS.phones[0]}</a>
                    </div>
                  </div>
                  <div className="office-mail">
                    <div className="mail-icon">
                      <i className="far fa-envelope" />
                    </div>
                    <div className="email">
                      {emails.info && (
                        <a href={`mailto:${emails.info}`} className="email-link">
                          {emails.info}
                        </a>
                      )}
                      {emails.support && (
                        <a href={`mailto:${emails.support}`} className="email-link">
                          {emails.support}
                        </a>
                      )}
                      {!emails.info && !emails.support && (
                        <span>Cargando contacto...</span>
                      )}
                    </div>
                  </div>
                  <div className="address">
                    <div className="address-icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <address>
                      <p>Ciénega 6319-1, La Hacienda, 72570, Puebla, PUE., México</p>
                    </address>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-12 col-md-4 col-lg-4 col-xl-5">
                <div className="copy-txt">
                  <span>
                    Copyright 2011 <b><span style={{ color: '#75DAB4' }}>Gekkonect</span></b> | Design By{" "}
                    <Link style={{ color: '#75DAB4' }} to={"#"}>Gekkonect</Link>
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-8 col-xl-7">
                <ul className="footer-bottom-menu">
                  <li>
                    <Link to="#" onClick={handleModalShow}>Política de privacidad</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div
        className={`privacy-modal modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-modal-title"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable privacy-modal__dialog">
          <div className="modal-content privacy-modal__surface">
            <div className="modal-header privacy-modal__top">
              <div className="privacy-modal__title-wrap">
                <span className="privacy-modal__label">Legal</span>
                <h2 className="privacy-modal__title" id="privacy-modal-title">
                  Aviso de privacidad
                </h2>
              </div>
              <button
                type="button"
                className="btn-close privacy-modal__close"
                onClick={handleModalClose}
                aria-label="Cerrar aviso de privacidad"
              />
            </div>
            <div className="modal-body privacy-modal-body">
              <div className="privacy-content">
                <p className="last-updated">
                  Última actualización: {new Date().toLocaleDateString("es-MX")}
                </p>

                <section className="privacy-section">
                  <h6>1. Recopilación de información</h6>
                  <p>
                    En Gekkonect nos comprometemos a proteger su privacidad.
                    Recopilamos:
                  </p>
                  <ul>
                    <li>Datos de contacto básicos</li>
                    <li>Información técnica del dispositivo</li>
                    <li>Datos de uso del sitio web</li>
                  </ul>
                </section>

                <section className="privacy-section">
                  <h6>2. Uso de su información</h6>
                  <p>Su información nos permite:</p>
                  <ul>
                    <li>Mejorar nuestros servicios</li>
                    <li>Personalizar su experiencia</li>
                    <li>Mantener la seguridad de nuestros sistemas</li>
                    <li>Enviar actualizaciones relevantes</li>
                  </ul>
                </section>

                <section className="privacy-section">
                  <h6>3. Protección de datos</h6>
                  <p>
                    Implementamos medidas de seguridad avanzadas para proteger su
                    información, incluyendo:
                  </p>
                  <ul>
                    <li>Encriptación de datos</li>
                    <li>Protocolos de seguridad</li>
                    <li>Acceso restringido a datos personales</li>
                  </ul>
                </section>

                <section className="privacy-section">
                  <h6>4. Sus derechos</h6>
                  <p>Usted puede ejercer sus derechos ARCO:</p>
                  <ul>
                    <li>Acceso a sus datos</li>
                    <li>Rectificación de información</li>
                    <li>Cancelación de datos</li>
                    <li>Oposición al tratamiento</li>
                  </ul>
                </section>

                <section className="privacy-section">
                  <h6>5. Contacto</h6>
                  <p>Para ejercer sus derechos o resolver dudas:</p>
                  <div className="contact-info">
                    {emails.info && (
                      <p>
                        <i className="far fa-envelope" aria-hidden />
                        <a
                          href={`mailto:${emails.info}`}
                          className="privacy-mail-gap"
                        >
                          {emails.info}
                        </a>
                      </p>
                    )}
                    <p>
                      <i className="fas fa-phone-alt" aria-hidden />
                      <a href={BUSINESS.telHref[0]} className="privacy-mail-gap">
                        {BUSINESS.phones[0]}
                      </a>
                    </p>
                  </div>
                </section>
              </div>
            </div>
            <div className="modal-footer privacy-modal__actions">
              <button
                type="button"
                className="privacy-modal__btn"
                onClick={handleModalClose}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal-backdrop fade show privacy-modal-backdrop"
          aria-hidden="true"
        />
      )}
    </>
  );
}

export default Footer;